import React from 'react';
import { TableContainer as ChakraTableContainer } from '@chakra-ui/react';
// TableContainer is intentionally excluded from theming so we do this.
// See: https://github.com/chakra-ui/chakra-ui/issues/8166#issuecomment-2383821464
export const TableContainer = (props)=>{
    const defaultProps = {
        border: '1px solid',
        borderColor: 'stroke.light',
        borderRadius: 'base',
        whiteSpace: 'normal'
    };
    return /*#__PURE__*/ React.createElement(ChakraTableContainer, {
        ...defaultProps,
        ...props
    });
};

//# sourceMappingURL=table-container.js.map